import {
  AccountingsHttpService,
  AgendaSlotReservationsHttpService,
  AgendaSlotsHttpService,
  AssistantsHttpService,
  AttendingAccountingsHttpService,
  AuthHttpService,
  ContractsHttpService,
  DoctorAttendingsHttpService,
  DoctorSubstitutesHttpService,
  DoctorsHttpService,
  InvitationsHttpService,
  OfficesHttpService,
  ProspectsHttpService,
  ReferralsHttpService,
  SharedDocumentReadingHttpService,
  SharedDocumentsHttpService,
  SharedDocumentTrackingHttpService,
  SitesHttpService,
  UsersHttpService,
  WorkScheduleSlotsHttpService,
} from '@omecare/utils';
import envService from './env.service';

const assistantsHttpService = new AssistantsHttpService(envService.env.api.url);
const authHttpService = new AuthHttpService(envService.env.api.url);
const usersHttpService = new UsersHttpService(envService.env.api.url);
const invitationsHttpService = new InvitationsHttpService(
  envService.env.api.url,
);
const officesHttpService = new OfficesHttpService(envService.env.api.url);
const sitesHttpService = new SitesHttpService(envService.env.api.url);
const doctorAttendingsHttpService = new DoctorAttendingsHttpService(
  envService.env.api.url,
);

const doctorSubstitutesHttpService = new DoctorSubstitutesHttpService(
  envService.env.api.url,
);
const agendaSlotsHttpService = new AgendaSlotsHttpService(
  envService.env.api.url,
);
const agendaSlotReservationsHttpService = new AgendaSlotReservationsHttpService(
  envService.env.api.url,
);
const doctorsHttpService = new DoctorsHttpService(envService.env.api.url);

const workScheduleSlotsHttpService = new WorkScheduleSlotsHttpService(
  envService.env.api.url,
);

const accountingsHttpService = new AccountingsHttpService(
  envService.env.api.url,
);

const attendingAccountingsHttpService = new AttendingAccountingsHttpService(
  envService.env.api.url,
);

const contractsHttpService = new ContractsHttpService(envService.env.api.url);

const referralsHttpService = new ReferralsHttpService(envService.env.api.url);

const prospectsHttpService = new ProspectsHttpService(envService.env.api.url);

const sharedDocumentsHttpService = new SharedDocumentsHttpService(
  envService.env.api.url,
);

const sharedDocumentReadingHttpService = new SharedDocumentReadingHttpService(
  envService.env.api.url,
);

const sharedDocumentTrackingHttpService = new SharedDocumentTrackingHttpService(
  envService.env.api.url,
);

export default {
  assistants: assistantsHttpService,
  auth: authHttpService,
  users: usersHttpService,
  invitations: invitationsHttpService,
  offices: officesHttpService,
  sites: sitesHttpService,
  doctorAttendings: doctorAttendingsHttpService,
  doctorSubstitutes: doctorSubstitutesHttpService,
  agendaSlots: agendaSlotsHttpService,
  agendaSlotReservations: agendaSlotReservationsHttpService,
  doctors: doctorsHttpService,
  workScheduleSlots: workScheduleSlotsHttpService,
  accountings: accountingsHttpService,
  attendingAccountings: attendingAccountingsHttpService,
  contracts: contractsHttpService,
  referrals: referralsHttpService,
  prospects: prospectsHttpService,
  sharedDocuments: sharedDocumentsHttpService,
  sharedDocumentReading: sharedDocumentReadingHttpService,
  sharedDocumentTracking: sharedDocumentTrackingHttpService,
};
